import React from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";

function RadialSeparators(props) {
    return (
        <Grid sx={{height:32, position:'absolute'}} container spacing={0}>
            <Grid item xs={3}>
                <Box sx={{height:'100%', borderRight:'2.5px solid'}}></Box>
            </Grid>
            <Grid item xs={3}>
                <Box sx={{height:'100%', borderRight:'2.5px solid'}}></Box>
            </Grid>
            <Grid item xs={3}>
                <Box sx={{height:'100%', borderRight:'2.5px solid'}}></Box>
            </Grid>
            <Grid item xs={3}>
                <Box sx={{height:'100%', borderRight:'0px solid'}}></Box>
            </Grid>
        </Grid>
    )

}

export default RadialSeparators;
